import { Flex, Text } from "@mantine/core";

import { PublicPageContainer } from "../components";
import { HelperTextWithLink } from "../components";

const Page = () => (
  <PublicPageContainer>
    <Flex direction="column" gap={24} align="center" ta="center">
      <Text
        fz="3.75rem"
        lh={1.2}
        fw={700}
        c="var(--mantine-primary-color-filled)"
      >
        &#128519; Oops!
      </Text>
      <Text
        fz="2.125rem"
        lh={1.235}
        fw={700}
        c="var(--mantine-primary-color-filled)"
      >
        404 Page Not Found
      </Text>
      <HelperTextWithLink text="Get lost?" to="/" linkTitle="Return to home" />
    </Flex>
  </PublicPageContainer>
);

export default Page;
